import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import {
  CHARGE_PHASE,
  COMBAT_PHASE,
  DURING_GAME,
  HERO_PHASE,
  MOVEMENT_PHASE,
  SHOOTING_PHASE,
  START_OF_COMBAT_PHASE,
  START_OF_GAME,
  WARDS_PHASE,
  WOUND_ALLOCATION_PHASE,
} from 'types/phases'

// Add individual artifacts here, and access them in other files!
const Artifacts = {
  //Vanari
  /* 'Syari Pommel': {
    effects: [
      {
        name: `Syari Pommel`,
        desc: `The bearer starts the battle with 1 extra Aetherquartz reserve.`,
        when: [START_OF_GAME],
      },
    ],
  },
  'Senlui Amulet': {
    effects: [
      {
        name: `Senlui Amulet`,
        desc: `The bearer can run and still charge in the same turn.`,
        when: [MOVEMENT_PHASE, CHARGE_PHASE],
      },
    ],
  }, */
  Waystone: {
    effects: [
      {
        name: `Waystone`,
        desc: `Effect: Remove this unit from the battlefield and set it up again wholly within friendly territory and more than 9" from all enemy units.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  //Scinari
  'Pheonix Stone': {
    effects: [
      {
        name: `Pheonix Stone - Passive`,
        desc: `Effect: The first time this unit would be destroyed, before removing it from play, roll a dice. On a 3+, this unit is not destroyed and any remaining damage points inflicted on it have no effect. Then, Heal (D3) this unit.`,
        when: [DURING_GAME],
      },
    ],
  },
  'Silver Wand': {
    effects: [
      {
        name: `Silver Wand - Passive`,
        desc: `Effect: If this unit is not a Wizard, it can use the 'Unbind' ability as if it had Wizard (1). Otherwise, add 1 to casting rolls for this unit.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Aelementiri Conclave (AoR)': {
    effects: [
      {
        name: `Aelementor Focus`,
        desc: `Declare: Pick a terrain feature to be the target.
        Effect: Measure the range and visibility of the next Spell ability used by this unit from the target instead of from this unit.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Vanari Paragons (AoR) - Swiftfeather Talisman': {
    effects: [
      {
        name: `Swiftfeather Talisman`,
        desc: `Declare: Pick a friendly Lumineth Realm-Lords unit wholly within 12" of this unit to be the target.
        Effect: Add 2" to the target's Move characteristic for the rest of the turn.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  'Vanari Paragons (AoR) - Nullstone Beads': {
    effects: [
      {
        name: `Nullstone Beads - Passive`,
        desc: `Effect: This unit can use the 'Unbind' ability as if it had Wizard (1).`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Vanari Paragons (AoR) - Phoenix Blade': {
    effects: [
      {
        name: `Phoenix Blade - Passive`,
        desc: `Effect: This unit's combat attacks score critical hits on unmodified hit rolls of 5+.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

// Always export using tagAs
export default tagAs(Artifacts, 'artifact')
